<template>
    <vProjectPreview :views="views" v-model="chosenView">
        <vPreviewIframe
            v-if="isCookieView"
            :src="`/preview/cookie-cookie/${cookie.uuid}`"
            back="#fff"
        />

        <vPreviewIframe
            v-if="isAdjustView && cookie.adjustShow"
            :src="`/preview/cookie-adjust/${cookie.uuid}`"
            back="#fff"
        />

        <vPreviewIframe v-if="isInfoView" :src="`/preview/cookie-info`" back="#fff" />
    </vProjectPreview>
</template>

<script>
import { COOKIE_PREVIEW_KIND } from "@/apps/cookie/cookie.routes";
import { mapActions, mapMutations, mapState } from "vuex";
import { CookieIcon, CogIcon } from "@easy/ui/icons";
import vPreviewIframe from "@/shared/views/vPreviewIframe.vue";
import vProjectPreview from "@/shared/views/vProjectPreview.vue";

export default {
    name: "CookieProjectPreview",
    components: {
        vPreviewIframe,
        vProjectPreview,
    },

    mounted() {
        this.$watch(
            () => [this.cookie, this.size, this.chosenView, this.lang],
            () => this.refreshIframe(),
            {
                immediate: true,
                deep: true,
            }
        );
        this.$watch(
            () => this.chosenView,
            () => this.setIframeLoaded(false)
        );
    },
    data() {
        return {
            chosenView: COOKIE_PREVIEW_KIND.cookie,
        };
    },
    computed: {
        ...mapState(["lang"]),
        ...mapState("cookie", ["cookie"]),
        views() {
            return [
                {
                    label: this.$t("cookie.views.cookie"),
                    value: COOKIE_PREVIEW_KIND.cookie,
                    icon: CookieIcon,
                },
                this.cookie.adjustShow
                    ? {
                          label: this.$t("cookie.views.adjust"),
                          value: COOKIE_PREVIEW_KIND.adjust,
                          icon: CogIcon,
                      }
                    : {},
            ];
        },
        isCookieView() {
            return this.chosenView === COOKIE_PREVIEW_KIND.cookie;
        },
        isAdjustView() {
            return this.chosenView === COOKIE_PREVIEW_KIND.adjust;
        },
        isInfoView() {
            return this.chosenView === COOKIE_PREVIEW_KIND.info;
        },
        fontFamilyStyle() {
            return { "font-family": this.cookie.fontFamily };
        },
    },
    methods: {
        ...mapMutations("cookie", ["setIframeLoaded"]),
        ...mapActions("cookie", ["refreshIframe"]),
    },
};
</script>
